<ng-container *transloco="let t; read: 'absenceGroups'">
  <kendo-grid
    [data]="absenceGroups$ | async"
    [skip]="gridState.skip"
    [pageSize]="gridState.pageSize"
    [pageable]="true"
    (pageChange)="onPageChange($event)"
    scrollable="none"
    [selectable]="reviewMode ? { enabled: true, checkboxOnly: true, mode: 'multiple' } : false"
    [kendoGridSelectBy]="'id'"
    [(selectedKeys)]="selectedIds"
  >
    <ng-template *ngIf="reviewMode && ('Permissions.AbsenceGroups.SignEntry' | permission)" kendoGridToolbarTemplate>
      <button
        kendoButton
        themeColor="success"
        [disabled]="!selectedIds.length"
        (click)="onConfirmSelected()"
        loadingIndication="/AbsenceGroup/updateAbsenceGroupState"
      >
        {{ t('confirmSelected') }}
      </button>
    </ng-template>

    <kendo-grid-checkbox-column
      *ngIf="reviewMode"
      [width]="40"
      [showSelectAll]="true"
    ></kendo-grid-checkbox-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="dateFrom"
      [title]="t('dateFrom')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.dateFrom | date : "dd.MM.yyyy" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="dateTo"
      [title]="t('dateTo')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.dateTo | date : "dd.MM.yyyy" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="isAdminView"
      media="(min-width: 450px)"
      field="employee"
      [title]="t('employee')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.employee?.firstName + " " + dataItem.employee?.lastName }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="absenceType"
      [title]="t('absenceType')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ t("absenceTypes." + absenceTypes[dataItem.absenceType]) }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="title"
      [title]="t('title')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="absenceState"
      [title]="t('absenceState')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ t("absenceStates." + absenceStates[dataItem.absenceState]) }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="durationAsDays"
      [title]="t('duration')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="signedBy"
      [title]="t('signedBy')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.signedById">
          <p>
            {{
              t("signedBy") +
                ": " +
                dataItem.signedBy.firstName +
                " " +
                dataItem.signedBy.lastName
            }}
          </p>
          <p>
            {{
              t("signedOn") + ": " + (dataItem.signedOn | date : "dd.MM.yyyy")
            }}
          </p>
        </ng-container>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      [title]="t('action')"
      *ngIf="isAdminView || canWithdraw"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- Self-service: pull back an own request while nobody has decided on it yet. -->
        <button
          *ngIf="canWithdraw && dataItem.absenceState === absenceStates.Open"
          kendoButton
          fillMode="solid"
          size="medium"
          rounded="medium"
          themeColor="warning"
          class="mbs mrs"
          (click)="onWithdrawAbsence(dataItem.id)"
          loadingIndication="/AbsenceGroup/withdrawAbsenceGroup"
        >
          {{ t('withdrawAbsenceButton') }}
        </button>

        <ng-container *ngIf="isAdminView && !dataItem.signedById">
        <button
            *ngIf="('Permissions.AbsenceGroups.SignEntry' | permission)"
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="success"
            class="mbs mrs"
            (click)="onAcceptAbsence(dataItem.id)"
            loadingIndication="/AbsenceGroup/updateAbsenceGroupState"
          >
            {{t('acceptAbsenceButton')}}
          </button>

          <button
            *ngIf="('Permissions.AbsenceGroups.SignEntry' | permission)"
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="error"
            class="mbs mrs"
            (click)="onDeclineAbsenceGroup(dataItem.id)"
            loadingIndication="/AbsenceGroup/updateAbsenceGroupState"
          >
            {{t('declineAbsenceButton')}}
          </button>

        </ng-container>

        <button
          *ngIf="isAdminView && dataItem.signedById && ('Permissions.AbsenceGroups.Delete' | permission)"
          kendoButton
          fillMode="solid"
          size="medium"
          rounded="medium"
          themeColor="error"
          class="mbs mrs"
          (click)="onDeleteAbsence(dataItem.id)"
          loadingIndication="/AbsenceGroup/deleteAbsenceGroup"
        >
          {{t('deleteAbsenceButton')}}
        </button>

    </ng-template>
    </kendo-grid-column>

    <!-- Mobile View -->
    <kendo-grid-column media="(max-width: 450px)" [title]="t('entries')">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- template for mobile -->
        <h4 [class.discontinued]="dataItem.Discontinued">
          {{ dataItem.dateFrom | date : "dd.MM.yyyy" }} - {{ dataItem.dateTo | date : "dd.MM.yyyy" }}
        </h4>

        <dl>
          <dt>{{ t('absenceType') }}</dt>
          <dd>{{ t("absenceTypes." + absenceTypes[dataItem.absenceType]) }}</dd>
        </dl>
        <dl>
          <dt>{{ t('absenceState') }}</dt>
          <dd>{{ t("absenceStates." + absenceStates[dataItem.absenceState]) }}</dd>
        </dl>
      </ng-template>
    </kendo-grid-column>

    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <div class="flex flexDirRow">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons
          [buttonCount]="5"
        ></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <div>
        <label for="pageBtnGroup" class="mrs">{{ t('resultsPerPage') }}</label>
        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
          <button
            (click)="onPageSizeChange(pageSizes.Small)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Small"
            [toggleable]="true"
          >
            {{ pageSizes.Small }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Medium)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Medium"
            [toggleable]="true"
          >
            {{ pageSizes.Medium }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Large)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Large"
            [toggleable]="true"
          >
            {{ pageSizes.Large }}
          </button>
        </kendo-buttongroup>

        <button
          kendoButton
          [title]="t('refresh')"
          (click)="onGridReload()"
          icon="reload"
        ></button>
      </div>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t('noResults') }}</div>
    </ng-template>
  </kendo-grid>
</ng-container>
